<template>

    <div class="card card-content">
        
      <v-card :max-width ="$vuetify.breakpoint.xs ? '70vw' : '30vw'">
      <v-expansion-panels>
      <v-expansion-panel @click="getCircleAnswersToday()" class="m4u_tertiary"
      :width ="$vuetify.breakpoint.xs ? '70vw' : '30vw'">
            <div class="m4u_tertiary" v-if="showForm === true" >
            <h4 class="m4u_text--text m4u_tertiary" >{{ qc.ViewPointQ}}</h4>

          <v-form class="m4u_tertiary" :width ="$vuetify.breakpoint.xs ? '70vw' : '30vw'">
            <v-row class="mt-3">
          <v-text-field
          dense
            v-model="myanswer"
            label="Enter Your Answer"
            color="m4u_text--text"
            class="myAnswerField ml-5 mr-5 m4u_text--text custom-label-color"
          ></v-text-field> <v-btn class="primary mt-1 mr-5 ml-5 mb-3 m4u_text--text" small @click="saveAnswer(vpanswerid)">Save</v-btn>
          </v-row>
          </v-form>
          </div>

        <v-expansion-panel-header  class="m4u_tertiary">
          <v-row>
            <h4  class="m4u_text--text" v-if="showForm">See answers</h4>
             <h4  class="m4u_text--text"  v-if="!showForm">{{ qc.ViewPointQ}}</h4>
             </v-row>
          </v-expansion-panel-header>
        <v-expansion-panel-content class="m4u_tertiary">
          <div class="mt-4" v-if="showForm === false" >
            <v-row class="m4u_text--text">
           <strong> Me: </strong> {{myanswer}} <v-btn class="mb-2" sm icon @click="showForm=true"><v-icon>mdi-pencil</v-icon></v-btn>
            </v-row>
            </div>
          <div v-for="answer in circleanswer" :key="answer.VPAnswerID" class="m4u_tertiary mt-3">
            <v-row class="m4u_text--text">
          <strong>{{answer.UserDisplayName}}: </strong> {{answer.VPAnswer}} 
          </v-row>
          </div>

        </v-expansion-panel-content>
      </v-expansion-panel>
      </v-expansion-panels>
      </v-card>
    </div>
</template>
<script>
import EventService from '@/services/EventService.js'; 

export default {
  data() {
    return {
      myanswer: '',
      today: '',
      icons: ['mdi-check'],
      circleanswer: [],
      vpanswerid: '',
      vpanswer: '',
      showForm: 'true',
      headers: [
        {
          text: 'Circle Member',
          align: 'start',
          sortable: false,
          value: 'UserDisplayName',
        },
        { text: 'Answer', value: 'VPAnswer' },
      ],
       }
    },
  props: ["qc"],
 mounted() {
   
    this.getMyQCAnswerToday();
    this.getCircleAnswersToday();
  },
   computed: {
  user(){
    return this.$store.state.user
  },
  vpID() {
    var vpID = this.qc.ViewPointID
    return vpID
  }
   },
 methods: {

    async getTodaysDate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      this.today = yyyy + '-' + mm + '-' + dd;
     return this.today
    },
  
    async getMyQCAnswerToday() {
      this.today = await this.getTodaysDate();
      const myanswer = await EventService.getMyQCAnswerToday(this.user.UserID, this.today)

          if( myanswer.length !== 0) {
            this.showForm = false;
          this.$set(this, "myanswer", myanswer[0].VPAnswer);
          this.$set(this, "vpanswerid", myanswer[0].VPAnswerID);
          }
          else {
             this.$set(this, "showForm", true);
          }
    },

    async getCircleAnswersToday() {
        this.today = await this.getTodaysDate();
      await EventService.getCircleAnswersToday(this.user.UserID, this.today)
      .then(
        (circleanswer => {
          this.$set(this, "circleanswer", circleanswer);
        }).bind(this)

      );
    },
    async saveAnswer(VPAnswerID) {
      await EventService.saveMyAnswer(this.user.UserID, this.qc.ViewPointID, this.myanswer, VPAnswerID)
            .then( async () => {
              await this.getMyQCAnswerToday()
            }
      );
    }
 }
}


</script>
<style lang="scss" scoped>
.card {

  height: auto;
  background-position: center;
  background-size: cover;
  text-align: center;
}
.card-content {
  color: #fff2e6;
  background-color: rgba(0, 0, 0, 0.35);


  span {
    font-size: 18px;
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 10px;
    right: 0;
  }
  h2 {
    margin-top: 10px;
  }
}

.custom-label-color .v-label {
  color: #250E62;
  opacity: 1;
}

.event-date {
  background-color: #151515;
  color: #fff;
  font-size: 0.75em;
  padding: 2px 10px;
  position: absolute;
  top: 0;
  right: 0;
}

.myAnswerDiv{
  display: inline;
}

.myAnswerField{
  max-width: 80%;
}
.questionDiv {
  display: block;
}
</style>